var map = {
	"./bulletin/home_button_newsbg.svg": "d17a",
	"./bulletin/home_button_primary.svg": "489e",
	"./bulletin/home_button_secondary.svg": "9c44",
	"./bulletin/home_text_newsbg.svg": "e6d2",
	"./bulletin/home_text_primary.svg": "d6b7",
	"./bulletin/home_text_secondary.svg": "914f",
	"./bulletin/stroke_alert.svg": "03a9",
	"./bulletin/stroke_copy.svg": "1df5",
	"./common/arrow_down.svg": "0150",
	"./common/arrow_up.svg": "d0a2",
	"./common/calendar.svg": "107b",
	"./common/check.svg": "8d58",
	"./common/close.svg": "1e58",
	"./common/edit.svg": "91f7",
	"./common/file_check.svg": "e23e",
	"./common/level.svg": "0322",
	"./common/move.svg": "1f9c",
	"./common/notify.svg": "b54a",
	"./common/org_icon.svg": "07c3",
	"./common/phone.svg": "f120",
	"./common/refresh.svg": "f812",
	"./common/sa_only.svg": "3051",
	"./common/scanner.svg": "0516",
	"./common/scanner_gun.svg": "a2e1",
	"./common/shop_icon.svg": "5d49",
	"./common/stars.svg": "cadc",
	"./common/ticket.svg": "a795",
	"./common/trash.svg": "b2d1",
	"./common/upRightFromSquare.svg": "034e",
	"./common/warning.svg": "980f",
	"./memberCenter/coupon_primary.svg": "3d4b",
	"./memberCenter/coupon_secondary.svg": "83f0",
	"./memberCenter/home_primary.svg": "b9b7",
	"./memberCenter/home_secondary.svg": "edbf",
	"./memberCenter/list_primary.svg": "7bb1",
	"./memberCenter/notification.svg": "9ed9",
	"./memberCenter/record_primary.svg": "996d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a627";